import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { baseURL } from './backend_url';
import axios from 'axios';
import './ActiveLocationsExternal.css';
import Swal from 'sweetalert2';
import { useSafeLayoutEffect } from '@chakra-ui/react';
import { Modal, Button, Form } from 'react-bootstrap';

function ActiveLocationsExternal() {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("123456");
  const [locationAll, setLocationAll] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [allLocationData, setAllLocationData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [hashLocationNameVsIDRMS, setHashLocationNameVsIDRMS] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [modalType, setModalType] = useState("add");
  const [locationDetail, setLocationDetail] = useState([]);
  const [newLocation, setNewLocation] = useState("");
  const [access, setAccess] = useState("Edit");

  // useEffect(() => {
  //   axios.get(baseURL + "/get_company_details_for_users")
  //     .then((res) => {
  //       setCompanyDetail(res.data);
  //     });
  // }, []);

  useEffect(() => {
    if (companyName) {

      let companyIdTemp = "690337"
      axios.get(baseURL + "/get_company_location/" + companyIdTemp)
        .then((res_1) => {
          axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
            .then((res1_1) => {
              let allTemp_1 = res_1.data.res;
              let hashLocationNameId = {};
              allTemp_1.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
              setHashLocationNameVsIDRMS(hashLocationNameId);
              if (allTemp_1.length > 0) {
                let tempArr = [];
                for (let i = 0; i < allTemp_1.length; i++) {
                  if (res1_1.data[allTemp_1[i].location_id] === true) {
                    tempArr.push(allTemp_1[i]);
                  }
                }
                console.log("--tempArr--",tempArr)
                setLocationDetail(tempArr);
              }

      let companyIdTemp = "123456"
      
      setCompanyId(companyIdTemp);
      axios.get(baseURL + "/srt_get_external_location")
        .then((res) => {
          axios.get(baseURL + "/srt_get_external_active_location/" + companyIdTemp.toString())
            .then((res1) => {

              let allTemp = res.data.res;
              let hashLocationNameId = {};
              allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
              setHashLocationNameVsID(hashLocationNameId);
              if (allTemp.length > 0) {
                let tempArr = [];
                let tempObj = {};
                for (let i = 0; i < allTemp.length; i += 4) {
                  let tempArr2 = [];
                  for (let j = i; j < i + 4; j++) {
                    if (allTemp[j]) {
                      tempArr2.push(allTemp[j].location_id);

                      if (res1.data[allTemp[j].location_id] == true) {
                        tempObj[allTemp[j].location_id] = true;
                      }
                      else {
                        tempObj[allTemp[j].location_id] = false;
                      }
                    }
                  }
                  tempArr.push(tempArr2);
                }

                setAllLocationData(tempArr);
                setSelectedLocation(tempObj);

                    

              }
            })
        });
      })
    })

      // }
    }
  }, []);

  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name, label: value.company_name
  }));

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleLocationAll = (checked) => {
    setLocationAll(checked);
    const updatedSelectedLocations = { ...selectedLocation };
    Object.keys(updatedSelectedLocations).forEach(key => {
      updatedSelectedLocations[key] = checked;
    });
    setSelectedLocation(updatedSelectedLocations);
  };

  const handleLocation = (locationId) => {
    setSelectedLocation(prevState => {
      const updatedState = {
        ...prevState,
        [locationId]: !prevState[locationId]
      };
      const allSelected = Object.values(updatedState).every(val => val === true);
      setLocationAll(allSelected);
      return updatedState;
    });
  };

  const handleSubmit = () => {
    const selectedLocations = Object.keys(selectedLocation).filter(key => selectedLocation[key]);
    console.log('Selected Locations:', selectedLocations);
    // further actions here
    if (companyName === "") {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select Account Name to proceed ahead',
      })
      return;
    }
    const obj = {
      'account_id': companyId.toString(),
      selectedLocation: selectedLocation,
      updated_by: 'demo@routes.ca'
    }
    axios.post(baseURL + "/srt_save_external_active_locations", obj)
      .then((res) => {
        Swal.fire({
          position: 'middle',
          icon: 'success',
          title: 'Saved Successfully!',
          showConfirmButton: false,
          timer: 3000
        })
      })
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsIDRMS[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId)
  }

  const handleSave = () => {

    if (newLocation === "") {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please enter new location name to proceed ahead',
      })
      return;
    }
    if (locationName === "") {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select corresponding corporate location to proceed ahead',
      })
      return;
    }
    Swal.fire({
      title: 'Do you want to save this ?',
      text: 'Note: This step is not reversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, proceed!',
      cancelButtonText: 'No, cancel'
    }).then((result) => {
      if (result.isConfirmed) {

    const obj = {
      'account_id': "123456",
      newLocation: newLocation,
      corporate_locationName: locationId,
      updated_by: 'demo@routes.ca'
    }
    axios.post(baseURL + "/srt_save_external_locations", obj)
      .then((res) => {
        if(res.data === 'already_exist'){
          Swal.fire({
            position: 'middle',
            icon: 'error',
            title: 'Location Name Already Exists',
          })
          return;
        }
        else{
          
        Swal.fire({
          position: 'middle',
          icon: 'success',
          title: 'Saved Successfully!',
          showConfirmButton: false,
          timer: 3000
        })
      }
        setShowModal(false);
        setLocationName("");
        setLocationId("");
        setNewLocation("");
        
      let companyIdTemp = "123456"
      
      setCompanyId(companyIdTemp);
      axios.get(baseURL + "/srt_get_external_location")
        .then((res) => {
          axios.get(baseURL + "/srt_get_external_active_location/" + companyIdTemp.toString())
            .then((res1) => {

              let allTemp = res.data.res;
              let hashLocationNameId = {};
              allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
              setHashLocationNameVsID(hashLocationNameId);
              if (allTemp.length > 0) {
                let tempArr = [];
                let tempObj = {};
                for (let i = 0; i < allTemp.length; i += 4) {
                  let tempArr2 = [];
                  for (let j = i; j < i + 4; j++) {
                    if (allTemp[j]) {
                      tempArr2.push(allTemp[j].location_id);

                      if (res1.data[allTemp[j].location_id] == true) {
                        tempObj[allTemp[j].location_id] = true;
                      }
                      else {
                        tempObj[allTemp[j].location_id] = false;
                      }
                    }
                  }
                  tempArr.push(tempArr2);
                }

                setAllLocationData(tempArr);
                setSelectedLocation(tempObj);
              }
              })
            })
      })

    }})
  }

  return (
    <div className="container mt-5">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">External Locations</h4>

        {companyName && (
          <div className="mb-4">
            <button className="btn btn-primary" onClick={() => { setShowModal(true) }}>+ New Location</button>
            <table className="table table-borderless mt-3">
              <tbody>
                {allLocationData.map((val, i) => (
                  <tr key={i}>
                    {val.map((val2, j) => (
                      <React.Fragment key={j}>
                        <td width='1px'>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedLocation[val2]}
                            onChange={() => handleLocation(val2)}
                          />
                        </td>
                        <td>{`${hashLocationNameVsID[val2]} `}</td>
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {companyName && (
          <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
        )}
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === "add" ? "Add New Location" : "Edit Location"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Location Name</Form.Label>
              <Form.Control
                type="text"
                value={newLocation}
                onChange={(e) => { setNewLocation(e.target.value) }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <label htmlFor="location_name" className="form-label">
                Corresponding Corporate Location
              </label>
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationDetail.map(location => ({
                  value: location.location_id,
                  label: `${location.location_name}`
                }))}
                onChange={handleInputChangeLocationName}
              />
            </Form.Group>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          <Button variant="success" onClick={handleSave}>Save changes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ActiveLocationsExternal;
